<template>
  <div>
    <DeviationPanel
      v-if="deviation"
      :deviation="deviation"
      @delete="deleteDeviation"
    />
    <DeviationDialog @update="updateDeviation" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import eventBus from '@/eventBus';

import {
  getDeviation,
  createDeviation,
  deleteDeviation,
} from '@/services/deviations';

import DeviationPanel from '@/components/deviation/DeviationPanel';
import DeviationDialog from '@/components/deviation/DeviationDialog';

export default {
  components: {
    DeviationPanel,
    DeviationDialog,
  },

  computed: {
    ...mapState('voip', ['deviation']),
    ...mapGetters('auth', ['currentUser']),
  },

  mounted() {
    getDeviation(this.currentUser.username).then(response => {
      this.setDeviation(response.data);
    });
  },

  methods: {
    ...mapActions('voip', ['setDeviation']),

    updateDeviation(to) {
      createDeviation(this.currentUser.username, to)
        .then(response => {
          this.setDeviation(response.data);
          eventBus.$emit('toggleDeviationDialog');
        })
        .catch(error => {
          this.$notify({
            type: 'error',
            title: this.$t('common.error'),
            text: error,
            duration: -1,
          });
        });
    },

    deleteDeviation() {
      deleteDeviation(this.deviation.from_username)
        .then(() => {
          this.setDeviation(null);
        })
        .catch(error => {
          this.$notify({
            type: 'error',
            title: this.$t('common.error'),
            text: error,
            duration: -1,
          });
        });
    },
  },
};
</script>
